import { render, staticRenderFns } from "./TasksTableOverview.vue?vue&type=template&id=13fc1978&scoped=true"
import script from "./TasksTableOverview.vue?vue&type=script&lang=ts"
export * from "./TasksTableOverview.vue?vue&type=script&lang=ts"
import style0 from "./TasksTableOverview.vue?vue&type=style&index=0&id=13fc1978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc1978",
  null
  
)

export default component.exports